import { Box } from '@mui/material'
import SEO from '../components/seo/SEO'
import StructuredData from '../components/seo/StructuredData'
import HeroSection from '../components/home/HeroSection'
import IdeasGallery from '../components/home/IdeasGallery'
import PricingSection from '../components/home/PricingSection'

const Home = () => {
  return (
    <>
      {/* SEO Meta Tags */}
      <SEO
        title="Mocksy - AI-Powered Product Photo Transformation"
        description="Transform your product photos with AI in seconds. Upload, describe, and generate professional product photography variations instantly. Perfect for e-commerce, marketing, and social media."
        keywords="AI product photos, product photography, AI image generation, e-commerce photos, product mockups, AI photo editor, professional product photos, automated product photography, AI product images"
        canonicalUrl="https://getmocksy.com/"
      />

      {/* Structured Data for SEO */}
      <StructuredData />

      {/* Main Content */}
      <Box component="main">
        <HeroSection />
        <Box id="ideas" component="section">
          <IdeasGallery />
        </Box>
        <Box id="pricing" component="section">
          <PricingSection />
        </Box>
      </Box>
    </>
  )
}

export default Home
